export const getAppName = () => {
  return import.meta.env.VITE_APP as string;
};

export const isAppName = (name: string) => {
  return getAppName() === name;
};
